import { withFormsy, propTypes } from "formsy-react";
import React from "react";
import { FormGroup, FormFeedback, Label, Input, FormText } from "reactstrap";
import { Spinner } from "..";

export class ViewTextInputComponent extends React.Component {
  render() {
    const errorMessage = this.props.getErrorMessage();
    const {
      className,

      showRequired,
      showError,
      getValue,
      showLoader,
      name,
      onKeyUp,
      title,
      placeholder,
      isPristine,
      type,
      infoText,
      hasValue,
      isRequired
    } = this.props;
    const hasError = !isPristine() && (showError() || !hasValue());

    return (
      <FormGroup className={className}>
        {title && (
          <Label className={isRequired() && "required"} htmlFor={name}>
            {title}
          </Label>
        )}
        <Input
          invalid={hasError}
          type={type || "text"}
          value={getValue() || ""}
          name={name}
          placeholder={placeholder}
          id={name}
          onKeyUp={onKeyUp}
          autoComplete="on"
        />
        {infoText ? <FormText>{infoText}</FormText> : ""}
        {hasError ? <FormFeedback>{errorMessage}</FormFeedback> : ""}
        {showRequired() ? <FormFeedback>Required</FormFeedback> : ""}
        {showLoader ? <Spinner /> : ""}
      </FormGroup>
    );
  }
}

ViewTextInputComponent.propTypes = {
  ...propTypes
};

const MyInput = withFormsy(ViewTextInputComponent);

export { MyInput as ViewDefaultTextInput };
